import styled from 'styled-components';

import { colors, radius } from '../../../../../../styles/tokens';

export const Container = styled.div`
  position: relative;
  overflow: hidden;

  background-color: ${colors.sidebar};
  border-radius: ${radius.DEFAULT};
  padding: 32px;

  &::before {
    content: '';
    position: absolute;
    top: -40px;
    right: -40px;

    width: 128px;
    height: 128px;
    border-radius: ${radius.full};

    background-color: ${colors.primary}0d;
    filter: blur(48px);
  }
`;

export const Title = styled.h3`
  position: relative;

  display: flex;
  align-items: center;
  gap: 8px;

  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${colors.onSurface};
  margin-bottom: 24px;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: ${radius.full};
    background-color: ${colors.primary};
  }
`;

export const Row = styled.div`
  position: relative;
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RowHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  span {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  span:first-child {
    color: ${colors.onSurface};
  }
`;

interface LevelProps {
  high?: boolean;
}

export const Level = styled.span<LevelProps>`
  color: ${({ high }) => (high ? colors.primary : colors.onSurfaceVariant)};
`;

export const Track = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${colors.surfaceContainer};
  border-radius: ${radius.full};
  overflow: hidden;
`;

interface BarProps {
  percent: number;
  high?: boolean;
}

export const Bar = styled.div<BarProps>`
  width: ${({ percent }) => percent}%;
  height: 100%;
  background-color: ${({ high }) =>
    high ? colors.primary : colors.primaryContainer};
`;

export const Empty = styled.p`
  position: relative;
  font-size: 12px;
  color: ${colors.onSurfaceVariant};
`;
